import { z } from 'zod'

export const ecommerceOrderScheduleEntrySchema = z.object({
  nextOccurrence: z.string().optional(),
  recurrenceSpec: z.object({
    validUntil: z.string().optional(),
  }),
})

export type ECommerceOrderScheduleEntry = z.infer<typeof ecommerceOrderScheduleEntrySchema>

export const ecommerceBaseProductSchema = z.object({
  sku: z.string(),
  attributes: z.object({
    planTitle: z.string().optional(),
    planDescription: z.string().optional(),
    planPriceText: z.string().optional(),
  }),
  priceInPenceIncludingTax: z.number(),
})

export type ECommerceBaseProduct = z.infer<typeof ecommerceBaseProductSchema>
